<template>
  <div>
    <el-row>
      <el-col>
        <el-form inline :model="form">
          <el-form-item label="月份：">
            <el-date-picker v-model="form.month" placeholder="请选择月份" value-format="yyyy-MM" type="month"
              :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>
          <el-button size="medium" @click="closeBill" style="margin-left:20px">设置关账</el-button>
        </el-form>
      </el-col>
    </el-row>
    <div style="background: white; border-radius: 3px">
      <el-row>
        <el-col :span="24">
          <el-table :data="tableData" stripe border>
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="MONTH" label="月份" min-width="80"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="small" type="text" @click="cancel(scope.row)">取消关账</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="关账失败，以下订单未完成" :visible.sync="unfinishedVisible" width="60%" center :close-on-click-modal="false"
      close-on-press-escape>
      <el-row v-if="unfinishedSale.length">
        销售单：
      </el-row>
      <el-row style="margin-top: 10px;" v-if="unfinishedSale.length">
        <el-table :data="unfinishedSale" border>
          <el-table-column label="订单编号" prop="ORDER_CODE"></el-table-column>
          <el-table-column label="送货日期" prop="SEND_DAY"></el-table-column>
          <el-table-column label="客户名称" prop="CUSTOMER_NAME"></el-table-column>
          <el-table-column label="项目点" prop="PROJECT_NAME"></el-table-column>
          <el-table-column label="档口" prop="DK_NAME"></el-table-column>
          <el-table-column label="状态" prop="STATUS"></el-table-column>
        </el-table>
      </el-row>
      <el-row style="margin-top: 20px;" v-if="unfinishedPurchase.length">
        采购单：
      </el-row>
      <el-row style="margin-top: 10px;" v-if="unfinishedPurchase.length">
        <el-table :data="unfinishedPurchase" border>
          <el-table-column label="订单编号" prop="ORDER_CODE"></el-table-column>
          <el-table-column label="送货日期" prop="SEND_DAY"></el-table-column>
          <el-table-column label="供应商" prop="CUSTOMER_NAME"></el-table-column>
          <el-table-column label="状态" prop="STATUS"></el-table-column>
        </el-table>
      </el-row>
      <el-row slot="footer">
        <el-button @click="() => unfinishedVisible = false">关闭</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      form: { month: '' },
      tableData: [],
      unfinishedVisible: false,
      unfinishedSale: [],
      unfinishedPurchase: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();// 如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
    };
  },
  created() {
    this.queryClosedMonth();
  },
  methods: {
    cancel({ MONTH, GYS_ID }) {
      this.$confirm('确定要取消关账吗?', '提示').then(() => {
        const params = {
          SERVICE_ID: '10001',
          OTYPE: 22,
          MONTH,
          GYS_ID,
        };
        http.post(params).then((res) => {
          this.$message.show({ text: '关账成功', type: 'success' });
          this.queryClosedMonth();
        }).catch((err) => this.$message.show({ text: err, type: 'error' }));
      });
    },
    closeBill() {
      const params = {
        SERVICE_ID: '10001',
        OTYPE: 21,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.form.month) {
        params.MONTH = this.form.month;
      } else {
        this.$message.show({ text: '请先选择月份', type: 'warning' });
        return false;
      }
      http.post(params).then((res) => {
        if (res.canModify) {
          this.$message.show({ text: '关账成功', type: 'success' });
          this.queryClosedMonth();
        } else {
          this.unfinishedSale = res.resultSaleList;
          this.unfinishedPurchase = res.resultPurchaseList;
          this.unfinishedVisible = true;
        }
      }).catch((err) => this.$message.show({ text: err, type: 'error' }));
    },
    queryClosedMonth() {
      const params = {
        SERVICE_ID: '10001',
        OTYPE: 20,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((res) => {
        this.tableData = res;
        sessionStorage.setItem('accountCloseList', JSON.stringify(res.map((item) => item.MONTH)));
      }).catch((err) => this.$message.show({ text: err, type: 'error' }));
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/financeCenter/financeCloseBill.vue